import React, { Fragment } from "react";
import FavoriteGifs from "../gifs/FavoriteGifs";

const Home = () => {
  return (
    <Fragment>
      <FavoriteGifs />
    </Fragment>
  );
};

export default Home;
